<template>
  <v-bottom-sheet v-model="stShowReadaloud" hide-overlay>
      <v-sheet class="text-right">
        <v-btn 
          icon
          color="primary"
          class="btn-close"
          @click="showReadaloud"
        >
          <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
        </v-btn>        
        <ReadAloud @close-reading="showReadaloud" />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import ReadAloud from '@/components/core/utils/ReadAloud.vue'

export default {
  data() {
    return {
      bottomReadAloudSheet: false
    };
  },
  components: {
    ReadAloud,
  },
  methods: {
    ...mapActions('bookReading', [
      'showReadaloud',
    ]),
  },
  props: [],
  computed: {
    ...mapState({
      stShowReadaloud: (state) => state.bookReading.mobileTools.showReadaloud,
    })
  },
  created() {
    // this.$root.$on('utilsToggle'); // Comentado porque no tiene función callback
  },
  beforeDestroy() {
    // Limpiar listeners si se agregan en el futuro
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>